export const formatPayMethod = (id) => {
  if (!id) return;
  if (id === 1) return 'Cartão de Crédito';
  if (id === 2) return 'Pix';
  if (id === 3) return 'Boleto';
  if (id === 4) return 'Cartão de Débito';
  if (id === 5) return 'Cartão de Crédito Recorrente';
};
